import type {
  TestHotspotFeedbackSchemaType,
  TestHotspotSchemaType,
} from '@vedalib/editor/lib/brand'
import lodash from 'lodash'

import Icon from 'components/uiKit/Icon'
import { KitSize } from 'components/uiKit/KitTypes'
import type { ElementFeedbackCss, ElementStyleCss } from 'services/Branding/types'

import * as s from './FeedbackIcon.module.scss'

interface IFeedbackIconProps {
  isTrueAnswer: boolean
  feedback: ElementFeedbackCss<TestHotspotFeedbackSchemaType>
  styles: ElementStyleCss<TestHotspotSchemaType>
}

const FeedbackIcon: React.FC<IFeedbackIconProps> = ({ isTrueAnswer, feedback, styles }) => {
  const commonStyles = { width: styles?.spot?.width, height: styles?.spot?.height }
  let content
  if (isTrueAnswer) {
    if (feedback?.correct.backgroundImage) {
      content = (
        <div
          className={s.image}
          style={{
            ...lodash.omit(feedback.common__var, 'marginRight'),
            ...commonStyles,
          }}
        />
      )
    } else {
      content = <Icon color={feedback?.correct?.color} name='success' size={KitSize.S} />
    }
  } else if (feedback?.incorrect?.backgroundImage) {
    content = (
      <div
        className={s.image}
        style={{
          ...lodash.omit(feedback.common__var, 'marginRight'),
          ...commonStyles,
        }}
      />
    )
  } else {
    content = <Icon color={feedback?.incorrect?.color} name='error' size={KitSize.S} />
  }

  return content
}

export default FeedbackIcon
